<div class="w-full px-6 py-8 space-y-10">

    <form [formGroup]="closureForm" (ngSubmit)="addClosure()" class="p-4" class="space-y-10">
        <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
            <div class="flex items-center gap-2 border-b pb-2">
                <div class="w-[4px] h-6 bg-primary"></div>
                <h2 class="text-xl font-semibold text-gray-800">Project Closure</h2>
            </div>
              <div class="user-group grid grid-cols-12  pt-4 px-6 gap-8">
            <div class="col-span-6">
                <mat-label>Title</mat-label>

                <mat-form-field appearance="outline" >
                    <input matInput formControlName="title">
                </mat-form-field>
            </div>

            <div class="col-span-6">
                <mat-label>Closure Process</mat-label>

                <mat-form-field appearance="outline" >
                    <input matInput formControlName="process">
                </mat-form-field>
            </div>
            <div class="col-span-6">
                <mat-label>Forms</mat-label>

                <mat-form-field appearance="outline" >
                    <input matInput formControlName="forms">
                </mat-form-field>
            </div>
            <div class="col-span-6">
                <mat-label>Actions</mat-label>

                <mat-form-field appearance="outline" >
                    <input matInput formControlName="actions">
                </mat-form-field>
            </div>
            <div class="col-span-6">
                <mat-label>Reporting</mat-label>

                <mat-form-field appearance="outline" >
                    <input matInput formControlName="reporting">
                </mat-form-field>
            </div>
            <div class="col-span-6">
                <mat-label>Deliverables</mat-label>

                <mat-form-field appearance="outline" >
                    <input matInput formControlName="deliverables">
                </mat-form-field>
            </div>
            </div>

            <button mat-raised-button color="primary" type="submit">Add</button>
        </div>
    </form>
</div>
